import React from 'react';
import classNames from 'classnames';
import { ProgressBar } from 'react-bootstrap';
import { applyContainerQuery } from 'react-container-query';
import styles from './CrewCapacities.css';

function getProgressBarStyle(percent) {
  if (percent > 1) {
    return 'danger';
  } else if (percent >= 0.80) {
    return 'warning';
  } else {
    return 'success';
  }
}

const mediaQuery = {
  [styles.spread]: {
    minWidth: 500
  },
  [styles.stacked]: {
    maxWidth: 499
  }
};

const CrewCapacities = ({ containerQuery, crew, events }) => {
  const equipment = (crew && crew.equipment) || {
    workCapacities: []
  };

  const estimatedDuration = events
    .filter((e) => e.job && !e.tentative)
    .map((e) => e.job.capacities.estimatedDuration || 0)
    .reduce((estimatedDuration, v) => estimatedDuration + v, 0);
  const laborAmount = events
    .filter((e) => e.job && !e.tentative)
    .map((e) => e.job.capacities.laborAmount || 0)
    .reduce((laborAmount, v) => laborAmount + v, 0);
  const materialLoad = events
    .filter(e => !e.tentative)
    .map(e => {
      if (e.job) {
        return e.job.capacities.materialQuantity || 0;
      } else if (e.purchaseOrder) {
        return e.purchaseOrder.loadCapacity || 0;
      } else {
        return 0;
      }
    })
    .reduce((materialLoad, v) => materialLoad + v, 0);

  const durationCapacity = equipment.workCapacities
    .filter((c) => c.capacityType === 'estimatedDuration')
    .map((c) => c.value)[0];
  const laborCapacity = equipment.workCapacities
    .filter((c) => c.capacityType === 'laborAmount')
    .map((c) => c.value)[0];
  const materialCapacity = equipment.workCapacities
    .filter((c) => c.capacityType === 'materialQuantity')
    .map((c) => c.value)[0];

  const estimatedDurationPercent = durationCapacity
    ? Math.round((estimatedDuration / durationCapacity) * 100) / 100
    : null;
  const laborPercent = laborCapacity
    ? Math.round((laborAmount / laborCapacity) * 100) / 100
    : null;
  const materialPercent = materialCapacity
    ? Math.round((materialLoad / materialCapacity) * 100) / 100
    : null;

  return (
    <div className={classNames(containerQuery)}>
      {!!laborCapacity && (
        <div className={styles.capacity}>
          <h4>Labor $</h4>
          <ProgressBar
            bsStyle={getProgressBarStyle(laborPercent)}
            label={`${(laborPercent * 100).toFixed(0)}%`}
            now={Math.min(laborPercent * 100, 100)}
          />
        </div>
      )}
      {!!materialCapacity && (
        <div className={styles.capacity}>
          <h4>Material Load</h4>
          <ProgressBar
            bsStyle={getProgressBarStyle(materialPercent)}
            label={`${(materialPercent * 100).toFixed(0)}%`}
            now={Math.min(materialPercent * 100, 100)}
          />
        </div>
      )}
      {!!durationCapacity && (
        <div className={styles.capacity}>
          <h4>Estimated Duration</h4>
          <ProgressBar
            bsStyle={getProgressBarStyle(estimatedDurationPercent)}
            label={`${(estimatedDurationPercent * 100).toFixed(0)}%`}
            now={Math.min(estimatedDurationPercent * 100, 100)}
          />
        </div>
      )}
    </div>
  );
};

export default applyContainerQuery(CrewCapacities, mediaQuery);
